import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { mapRoutes } from './map.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { MapComponent } from './map.component'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [MapComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(mapRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    ContentEditableModule,
  ],
  exports: [],
})
export class MapModule {}
